import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { TemplatesServices } from "../../../../services/templates";
import { ConfigurationServices } from '../../../../configuration/services';
import { CartaServices } from '../../../services';
import { Globals } from '../../../../../globals';

/**
 * Generated class for the MenuPartialCustomizeTemplatPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-carta-partial-customize-template',
  templateUrl: 'carta-page-customize-template.html',
})
export class CartaPageCustomizeTemplatPage {
  carta_uid: any;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public templateServices: TemplatesServices,
    public configurationServices: ConfigurationServices,
    public cartaServices: CartaServices,
    public globals: Globals) {
    this.carta_uid = this.navParams.get('carta_uid');

  }

  ionViewWillEnter() {
    this.templateServices.getListBasic();
    //this.templateServices.getListNadal();
  }

  update(value) {
    //cambiar fondo
    this.cartaServices.afs.collection('cartas').doc(this.carta_uid).update({
      'template': value,
    }).then(() => {
      this.navCtrl.pop();
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/carta/carta-view/carta-partial-customize-options/carta-page-customize-template/carta-page-customize-template.ts